/*
 *   Copyright (c) 2021 Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

console.log('spoketree-plugin-ui-exchange/example: index.js: env');
console.log('REACT_APP_STAGE', process.env.REACT_APP_STAGE);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<App />);

